import { getCapvaluelist } from '@/api';
import { echartslineColor } from '@/tool/utils';
import { useEffect, useState } from 'react';
import CardHead from '../cardHead';
import Echarts from '../echarts';
import PricePanel from '../pricePanel';
import { formatNumber } from "@/tool/utils";
import './index.scss';
import LoadingOutlined from '../loadingOutlined';


const types = ["USD", "ETH", "FIS"]

export default function Index() {

    const [typevlue, setTypeValue] = useState<string>("USD")


    const [updateTime, setUpdateTime] = useState<any>();
    const [yData, setYData] = useState<any>();
    const [echartList, setEchartList] = useState<any[]>([]);
    const [stakelistLoading, setStakelistLoading] = useState<boolean>(false);
    const [allRtokenValue, setAllRtokenValue] = useState<string | number>('')
    useEffect(() => {
        setStakelistLoading(true)
        getCapvaluelist().then((res) => {
            if (res.data.status == "80000") {
                const data = res.data.data;
                setUpdateTime(data.info.updateTime);
                setAllRtokenValue(data.info.allRtokenValue);

                setYData(data.list[0].rtokenValue.yData);
                const list = data.list.map((item: any, index: number) => {
                    item.color = echartslineColor[index];
                    item.name = item.rsymbol;
                    item.data = item.rtokenValue.data.map((item: any) => {
                        return Number(item)
                    });
                    item.type = 'line';
                    return item
                })
                setEchartList(list)
            }
        }).finally(() => {
            setStakelistLoading(false)
        })
    }, [])

    return <div className="marketCapContainer">
        <CardHead title="Market Cap" tips={`current rToken overall market cap (Market Cap = Current rToken Price x Circulating Supply. Refers to the total market value of a cryptocurrency’s circulating supply. It is similar to the stock market’s measurement of multiplying price per share by shares readily available in the market (not held & locked by insiders, governments))`} />
        <PricePanel text={<LoadingOutlined spin={stakelistLoading}>{`$${formatNumber(allRtokenValue, { decimals: 2 })}`}</LoadingOutlined>} notmt="notmt" />
        <Echarts selectType="node" types={types} onTypeChange={(value: string) => {
            setTypeValue(value)
        }} typeValue={typevlue} updateTime={updateTime} yData={yData} datas={echartList} loading={stakelistLoading} />
    </div>
}